
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { Form } from 'vee-validate';

import { useReCaptcha } from 'vue-recaptcha-v3';

import FormField from '@/components/forms/FormField.vue';

import { Auth } from '@/models/AuthModel';
import { AuthSchema } from '@/schemas/common.schemas';
import { Actions, Getters } from '@/store/enums/AuthEnums';
import toasts from '@/utils/toasts';

const initialValues = {} as unknown as Auth;

export default defineComponent({
  name: 'sign-in-form',
  emits: ['userLoggedIn'],
  components: {
    FormField,
    Form,
  },
  data: () => ({
    recaptcha_token: null,
    recaptcha_error: false,
    form: {} as typeof Form,
    formData: initialValues,
    loading: false,
    submitButton: {} as HTMLElement,
  }),
  mounted() {
    // setup the form reference
    this.form = this.$refs.loginForm as typeof Form;

    // setup the form reference
    this.submitButton = this.$refs.submitButton as HTMLElement;
  },
  computed: {
    ...mapGetters({
      loginErrors: Getters.GET_AUTH_ERROR,
    }),

    formSchema() {
      return AuthSchema;
    },
  },
  methods: {
    ...mapActions({
      userLogin: Actions.LOGIN,
    }),

    resetForm() {
      // Reset the form validation and values
      this.form.resetForm();

      // Reset the form values
      this.formData = initialValues;
    },

    setFieldValue(field, value) {
      if (!this.form.setFieldValue) return;

      this.form.setFieldValue(field, value);
    },

    async submitLoginForm(values) {
      if (this.loading) return;
      this.loading = true;

      const token = await this.recaptcha();

      if (!token) {
        this.recaptcha_error = true;
        this.loading = false;
        return;
      }

      this.formData = values;
      this.formData.recaptcha_token = token;

      this.userLogin(this.formData)
        .then(() => {
          this.loading = false;

          // this.$router.push({ name: 'dashboard' });
          window.location.replace(`${process.env.VUE_APP_BASE_URL}/dashboard`);
        })
        .catch(() => {
          this.loading = false;
          const { errors, message } = this.loginErrors;
          toasts.error(errors, message);
        });
    },
    validateFormField(field) {
      if (!this.form.validateField) return;

      this.form.validateField(field);
    },
  },
  setup() {
    const recaptchaInstance = useReCaptcha();

    const recaptcha = async () => {
      // (optional) Wait until recaptcha has been loaded.
      await recaptchaInstance?.recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await recaptchaInstance?.executeRecaptcha('login');

      // Do stuff with the received token.
      return token;
    };

    return {
      recaptcha,
    };
  },
});
